import Api from "./Api.js";

export default {
  treeview() {
    return Api.post("user-folder/");
  },
};
